import * as React from 'react';
import * as MobileDetect from 'mobile-detect';
import { AuthState } from '../auth/auth.types';
import AttendanceTableComponent from './attendance.table.component';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { red700, green700 } from 'material-ui/styles/colors';
import DataTables from 'material-ui-datatables';
import ActionCameraEnhance from 'material-ui/svg-icons/action/camera-enhance';
import { white, yellow500 } from 'material-ui/styles/colors';
import * as moment from 'moment';
import {
  AttendanceState,
  Attendance,
  CheckinState,
  FilterOption,
  AttendanceDetail,
  AttendanceDetails
} from './attendance.types';
import {
  Member,
  MembersDetailsMode,
  MembersState,
  MembersResponseData
} from '../members/members.types';
import {
  DefaultMemberPictureURL,
  DISPLAY,
  initialMemberDetail,
  TIME_BASED,
  CLASS_BASED,
  PACKAGE_BASED
} from '../members/members.constants';
import AttendanceMemberDetailsComponent from './AttendanceMemberDetailsComponent';
import { isAdminAccount, isImpersonating } from '../admin/Util';
import { AdminState } from '../admin/admin.types';
import { BusinessState } from '../business/business.types';
import { Account } from '../account/Types';
import { ATTENDANCE, STAFF } from '../account/Constants';
import { cannotWrite, isAttendancesDisabled, isPackageDisabled } from '../util/permission.util';
import * as Webcam from 'react-webcam';
import RefreshIndicator from 'material-ui/RefreshIndicator';
import ImageUploadComponent from '../util/ImageUploadComponent';
import { isAuthTokenExpired } from '../commons/AuthTokenValidator';
import { ProgramsState, Program } from '../programs/Types';
import CircularProgress from 'material-ui/CircularProgress';
import CommonFeatures from '../commons/CommonFeatures';
import { mmsStore } from '../app/app.config';
import { UPDATE_ATTENDANCE_AFTER_CHECKIN, DEFAULT_NOT_CHECKED_IN } from './attendance.constants';
import { overlayStyle, renderOverlayLoading } from '../util/Overlay';
import { isProgramDisabled } from '../util/permission.util';
import Dialog from 'material-ui/Dialog';
import { MmsPackage, PackageState } from 'src/mms-package/Types';
import { ActionYoutubeSearchedFor } from 'material-ui/svg-icons';
import { getPackages } from 'src/mms-package/Actions';
import ReactTable from 'react-table';
import { AutoComplete } from 'material-ui';
import { antiIdle, getAttendance } from './attendance.actions';
import { LARGE } from 'material-ui/utils/withWidth';
import { RSA_NO_PADDING } from 'constants';
import Members from 'src/members/Members';

const NOT_AVAILABLE = 'N/A';
const DIVIDER = ' / ';
var tokenRefresher;

type Props = {
  readonly authState: AuthState
  readonly adminState: AdminState
  readonly attendanceState: AttendanceState
  readonly checkinState: CheckinState
  readonly membersState: MembersState
  readonly programsState: ProgramsState
  readonly packageState: PackageState
  readonly getAttendance: (year: number, month: number) => Promise<Response>
  readonly checkinToday: (
    memberId: string,
    programId: number,
    accountId?: number,
    packageId?: number,
    noShow?: boolean
  ) => Promise<Response>
  readonly unCheckinToday: (memberId: string, time: number) => Promise<Response>
  readonly toAdminDashboard: () => void
  readonly toDashboard: () => void
  readonly getMembers: () => Promise<MembersResponseData>
  readonly getMember: (memberId: number) => Promise<MembersResponseData>
  readonly businessState: BusinessState
  readonly faceCheckin: (file: File, programId: number) => Promise<Response>
  readonly getPrograms: () => Promise<Response>
  readonly getPackages: () => Promise<Response>
};

type States = {
  readonly attendanceMember: Member
  readonly members: Array<Member>
  readonly attendanceMode: MembersDetailsMode
  readonly attendingMemberId: string
  readonly confirmationMessage: string
  readonly foundMember: Member
  readonly screenshot: string
  readonly loading: boolean
  readonly loadedAttendances: boolean
  readonly checkInProgram: Program
  readonly isApiCalledAlready: boolean
  readonly loadingUnCheckin: boolean
  readonly selectPackageModalOpen: boolean
  readonly loadingPackageSelectOrNoShow: boolean
  readonly noShowError: string
  readonly selectedStaffs: Account[]
  readonly memberPackages: Object
  readonly memberSearchData: string[]
  readonly memberSearchText: string
  readonly optionsOpen: boolean,
  readonly displayConfirmDialog: boolean
};

class AttendanceCheckInComponent extends React.Component<Props, States> {

  constructor(props: Props) {
    super(props);

    this.state = {
      attendanceMember: initialMemberDetail,
      members: [],
      attendanceMode: 'AUTO_ATTENDANCE',
      attendingMemberId: '',
      confirmationMessage: '',
      foundMember: initialMemberDetail,
      screenshot: '',
      loading: false,
      loadedAttendances: false,
      checkInProgram: undefined,
      isApiCalledAlready: false,
      loadingUnCheckin: false,
      selectPackageModalOpen: false,
      loadingPackageSelectOrNoShow: false,
      noShowError: '',
      selectedStaffs: [],
      memberPackages: new Object(),
      memberSearchData: [],
      memberSearchText: '',
      optionsOpen: false,
      displayConfirmDialog: false
    };
  }

  componentWillUnmount() {
    clearInterval(tokenRefresher);
    this.setState({
      loading: false,
      loadedAttendances: false,
      selectPackageModalOpen: false,
      loadingPackageSelectOrNoShow: false,
      noShowError: '',
      selectedStaffs: undefined
    });
  }

  componentDidMount() {
    const { authState, toAdminDashboard, adminState, toDashboard, getPrograms } = this.props;

    tokenRefresher = setInterval(() => antiIdle(), 900000);

    if (isAdminAccount(authState) && !isImpersonating(adminState)) {
      return toAdminDashboard();
    }

    if (!isPackageDisabled(authState, adminState)) {
      this.props.getPackages();
    }

    if (
      !isAttendancesDisabled(authState, adminState) &&
      !this.state.loadedAttendances &&
      !this.state.isApiCalledAlready
    ) {
      this.setState(
        { isApiCalledAlready: true },
        () => {
          this.loadMembersList();
          getPrograms();
        }
      );
    } else {
      toDashboard();
    }
  }

  render() {

    return (
      <CommonFeatures
        authState={this.props.authState}
        businessState={this.props.businessState}
      >
        <div className="page-header-row row mt-2">
          <div className="col-auto">
            <h3>Check In</h3>
          </div>
        </div>
        {this.renderAttendanceMemberDetailsPage()}
      </CommonFeatures>
    );
  }

  private renderAttendanceMemberDetailsPage = (): JSX.Element => {
    const { confirmationMessage } = this.state;

    const mobileDetect = new MobileDetect(window.navigator.userAgent);
    const focusMemberIdField = input => {
      if (input && innerWidth >= 1000) {
        input.focus();
      }
    };

    return (
      <div>
        <div className="row align-items-center">
          <div className="col-8 h3">
            {
              (confirmationMessage.length > 0) ?
                <div
                  className="float-left"
                  style={{
                    color: (
                      confirmationMessage.indexOf('invalid') === -1 &&
                      this.props.checkinState.statusCode === 200
                    ) ? green700 : red700,
                    fontSize: '15',
                    paddingTop: '5px',
                    paddingBottom: '5px'
                  }}
                >
                  {confirmationMessage}
                </div>
                : null
            }
          </div>
        </div>
        <div className="row">
          <div className="col-6 pt-4">
            <AutoComplete
              fullWidth={true}
              hintText="Member ID / Name"
              searchText={this.state.memberSearchText}
              onUpdateInput={this.onAttendingMemberIdChange}
              dataSource={this.state.memberSearchData}
              filter={AutoComplete.caseInsensitiveFilter}
              onNewRequest={this.handleNewMemberSearchRequest}
              maxSearchResults={5}
              ref={focusMemberIdField}
              openOnFocus={false}
              open={false}
            />
          </div>
          {/* <div className="col-6">
            <SelectField
              floatingLabelText="Select Program"
              value={this.state.checkInProgram}
              onChange={this.handleCheckInProgramChange}
              disabled={isProgramDisabled(this.props.authState, this.props.adminState)}
              fullWidth={true}
            >
              {<MenuItem value={NOT_AVAILABLE} primaryText={NOT_AVAILABLE} />}
              {
                isProgramDisabled(this.props.authState, this.props.adminState) ?
                  undefined :
                  this.renderProgramItems()
              }
            </SelectField>
            </div> */}
        </div>
        <div className="row">
          {
            (this.state.attendanceMode === 'MANUAL_ATTENDANCE') ?
              this.renderManualAttendanceModeButtons() :
              undefined
          }
        </div>
        <div className="row">
          <div className="col-xl-4 col-md-6 col-sm-12 pt-2">
            <div className="row">
              <div className="col-12 text-center">
                <Webcam
                  ref="webcam"
                  audio={false}
                  screenshotFormat="image/jpeg"
                  style={{ width: '100%', height: '100%' }}
                />
              </div>
              <div className="col-12">
                {this.renderTakePicButton()}
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-md-6 col-sm-12 pt-2 text-center">
            <ImageUploadComponent
              defaultImageUrl={
                this.state.attendanceMember.picUrl ?
                  this.state.attendanceMember.picUrl :
                  DefaultMemberPictureURL[this.state.attendanceMember.gender]
              }
              mode={DISPLAY}
              customMaxHeight={`${window.innerHeight / 3}`}
            />
            <AttendanceMemberDetailsComponent
              member={this.state.attendanceMember}
            />
          </div>
        </div>
        {this.renderConfirmationModal()}
      </div>
    );
  }

  private renderConfirmationModal = (): JSX.Element => {
    return (
      <Dialog
        open={this.state.displayConfirmDialog}
        autoScrollBodyContent={true}
        autoDetectWindowHeight={true}
        repositionOnUpdate={false}
        contentStyle={{
          width: '70%',
          height: '50%',
          maxWidth: 'none',
          maxHeight: 'none'
        }}
      >
        <div className="row">
          <div className="col">
            <div className="text-center">
              <div className="col">
                <ImageUploadComponent
                  defaultImageUrl={
                    this.state.foundMember.picUrl ?
                      this.state.foundMember.picUrl :
                      DefaultMemberPictureURL[this.state.foundMember.gender]
                  }
                  mode={DISPLAY}
                  customMaxHeight={`${window.innerHeight}`}
                />
              </div>
              <div className="col">
                <AttendanceMemberDetailsComponent
                  member={this.state.foundMember}
                />
              </div>
            </div>
          </div>
          <div className="col">
            {
              this.state.foundMember && this.state.foundMember.memberType === PACKAGE_BASED ?
                <div className="container">
                  <div className="col">
                    {
                      (this.state.confirmationMessage.length > 0) ?
                        <div
                          className="float-right"
                          style={{
                            color: (
                              this.state.confirmationMessage.indexOf('invalid') === -1 &&
                              this.props.checkinState.statusCode === 200
                            ) ? green700 : red700
                          }}
                        >
                          {this.state.confirmationMessage}
                        </div>
                        : null
                    }
                  </div>
                  <br />
                  <ReactTable
                    data={
                      this.getPackageByIds().map(p => {
                        return {
                          description: p.description,
                          remainingClasses: p.remainingClasses,
                          expiryDate: moment(new Date(p.expiryDate)).format('MMM Do YY')
                        };
                      })}
                    columns={[
                      {
                        Header: 'Description',
                        accessor: 'description',
                        style: { textAlign: 'center', paddingTop: 35 }
                      },
                      {
                        Header: 'Remaining Classes',
                        accessor: 'remainingClasses',
                        style: { textAlign: 'center', paddingTop: 35 }
                      },
                      {
                        Header: 'Expiry Date',
                        accessor: 'expiryDate',
                        style: { textAlign: 'center', paddingTop: 35 }
                      },
                      {
                        Header: 'Staff',
                        accessor: 'staff',
                        Cell: (cellInfo) => this.renderStaffSelect(
                          cellInfo
                        ),
                        style: { textAlign: 'center' }
                      },
                      {
                        Header: '',
                        accessor: 'select',
                        Cell: (cellInfo) => this.renderSelectButton(cellInfo),
                        style: { textAlign: 'center', paddingTop: 35 }
                      },
                      {
                        Header: '',
                        accessor: 'noshow',
                        Cell: (cellInfo) => this.renderNoshowButton(cellInfo),
                        style: { textAlign: 'center', paddingTop: 35 }
                      }
                    ]}
                    defaultPageSize={5}
                    className="-striped -highlight float-right col"
                  />
                </div> :
                this.state.foundMember && this.state.foundMember.programMembers
                  && this.state.foundMember.programMembers.length > 1 ?
                  this.state.foundMember.programMembers.map((p, index) => {
                    return <RaisedButton
                      key={index}
                      label={p.program.name}
                      secondary={true}
                      className="mx-3 my-1 float-right"
                      style={{ width: '70%' }}
                      onClick={() => {
                        this.setState({
                          checkInProgram: p.program,
                          attendingMemberId: this.state.foundMember.memberId
                        }, () => {
                          this.checkinToday();
                          setTimeout(this.clearCheckIn, 10000);
                        });
                      }}
                    />;
                  }) :
                  this.renderWithoutProgram()
            }
            {this.renderNotYou()}
          </div>
        </div>
      </Dialog>
    );
  }

  private renderWithoutProgram = (): JSX.Element => {
    return (
      <RaisedButton
        label="It's Me!"
        secondary={true}
        className="mx-3 my-1 float-right"
        style={{ width: '70%' }}
        onClick={() => {
          this.setState({
            displayConfirmDialog: false,
            checkInProgram: undefined,
            attendingMemberId: this.state.foundMember.memberId
          }, () => {
            this.checkinToday();
            setTimeout(this.clearCheckIn, 10000);
          });
        }}
      />);
  }

  private renderNotYou = (): JSX.Element => {
    return (
      <RaisedButton
        label="It's Not Me / Done"
        primary={true}
        className="mx-3 my-1 float-right"
        style={{ width: '70%' }}
        onClick={() => {
          this.setState(
            {
              displayConfirmDialog: false,
              foundMember: initialMemberDetail,
              checkInProgram: undefined
            }
          );
          setTimeout(this.clearCheckIn, 10000);
        }}
      />);
  }

  private renderSelectPackageModal = (): JSX.Element => {
    return (
      <Dialog
        title="Select A Package"
        actions={[this.renderCloseButton()]}
        open={this.state.selectPackageModalOpen}
        autoScrollBodyContent={true}
        repositionOnUpdate={false}
        onRequestClose={this.handleCloseButtonOnSelectPackage}
        contentStyle={{
          width: '70%',
          maxWidth: 'none',
        }}
      >
        <div className="col-8">
          {
            (this.state.confirmationMessage.length > 0) ?
              <div
                className="float-left"
                style={{
                  color: (
                    this.state.confirmationMessage.indexOf('invalid') === -1 &&
                    this.props.checkinState.statusCode === 200
                  ) ? green700 : red700
                }}
              >
                {this.state.confirmationMessage}
              </div>
              : null
          }
        </div>
        <br />
        <ReactTable
          data={
            this.getPackageByIds().map(p => {
              return {
                description: p.description,
                remainingClasses: p.remainingClasses,
                expiryDate: moment(new Date(p.expiryDate)).format('MMM Do YY')
              };
            })}
          columns={[
            {
              Header: 'Description',
              accessor: 'description',
              style: { textAlign: 'center', paddingTop: 35 }
            },
            {
              Header: 'Remaining Classes',
              accessor: 'remainingClasses',
              style: { textAlign: 'center', paddingTop: 35 }
            },
            {
              Header: 'Expiry Date',
              accessor: 'expiryDate',
              style: { textAlign: 'center', paddingTop: 35 }
            },
            {
              Header: 'Staff',
              accessor: 'staff',
              Cell: (cellInfo) => this.renderStaffSelect(
                cellInfo
              ),
              style: { textAlign: 'center' }
            },
            {
              Header: '',
              accessor: 'select',
              Cell: (cellInfo) => this.renderSelectButton(cellInfo),
              style: { textAlign: 'center', paddingTop: 35 }
            },
            {
              Header: '',
              accessor: 'noshow',
              Cell: (cellInfo) => this.renderNoshowButton(cellInfo),
              style: { textAlign: 'center', paddingTop: 35 }
            }
          ]}
          defaultPageSize={5}
          className="-striped -highlight"
        />
        <RaisedButton
          label="Close"
          secondary={true}
          className="float-right mr-3"
          style={{ margin: 15 }}
          onClick={this.handleCloseButtonOnSelectPackage}
        />
      </Dialog>
    );
  }

  private handleCloseButtonOnSelectPackage = () => {
    this.setState({ selectPackageModalOpen: false });
    setTimeout(this.clearCheckIn, 10000);
  }

  private renderNoshowButton = (cellInfo) => {
    const { foundMember, loadingPackageSelectOrNoShow, memberPackages } = this.state;
    const { packageState, businessState } = this.props;
    return (!loadingPackageSelectOrNoShow ?
      (
        <RaisedButton
          label="No Show"
          secondary={true}
          className="mr-3"
          onClick={() => this.handleSelectPackage(foundMember,
            packageState.packages.find(p => p.id === memberPackages[cellInfo.index]['id'])
            , memberPackages[cellInfo.index]['staff'], true)}
          disabled={!memberPackages[cellInfo.index]['staff']}
        />
      ) :
      (
        <RefreshIndicator
          size={30}
          left={10}
          top={0}
          status="loading"
          style={{
            display: 'inline-block',
            position: 'relative',
            marginLeft: '20%'
          }}
        />
      )
    );
  }

  private renderSelectButton = (cellInfo) => {
    const { foundMember, loadingPackageSelectOrNoShow, memberPackages } = this.state;
    const { packageState } = this.props;
    return (!loadingPackageSelectOrNoShow ?
      (
        <RaisedButton
          label="Select"
          primary={true}
          className="mr-3"
          onClick={() => this.handleSelectPackage(foundMember,
            packageState.packages.find(p => p.id === memberPackages[cellInfo.index]['id'])
            , memberPackages[cellInfo.index]['staff'], false)}
          disabled={!memberPackages[cellInfo.index]['staff']}
        />
      ) :
      (
        <RefreshIndicator
          size={30}
          left={10}
          top={0}
          status="loading"
          style={{
            display: 'inline-block',
            position: 'relative',
            marginLeft: '20%'
          }}
        />
      )
    );
  }

  private renderStaffSelect = (cellInfo) => {
    const { businessState } = this.props;
    const staffs = businessState.business && businessState.business.accounts;
    return (
      <SelectField
        floatingLabelText="Select Staff"
        fullWidth={true}
        value={this.state.memberPackages[cellInfo.index]['staff']}
        onChange={(e, index, m) => {
          const data = { ...this.state.memberPackages };
          data[cellInfo.index]['staff'] = m;
          this.setState({ memberPackages: data });
        }}
        style={{ paddingTop: 0, marginTop: 0 }}
      >
        {
          staffs && staffs.map((a: Account, index: number) => {
            return <MenuItem
              key={index}
              value={a}
              primaryText={a.firstName + ' ' + a.lastName}
            />;
          })
        }
      </SelectField>);
  }

  private getPackageByIds = (): MmsPackage[] => {
    const { foundMember } = this.state;
    const { packageState } = this.props;
    return foundMember.packageIds ?
      packageState.packages.filter(p => foundMember.packageIds.includes(p.id))
      : [];
  }

  private getPackageByIdsArray = (ids: number[]): MmsPackage[] => {
    const { packageState } = this.props;
    return packageState.packages.filter(p => ids.includes(p.id));
  }

  private renderCloseButton = (): JSX.Element => {
    const { attendanceMember } = this.state;

    if (attendanceMember && (
      (attendanceMember.packageIds && attendanceMember.packageIds.length === 0) ||
      !attendanceMember.packageIds
    )) {
      return (
        <RaisedButton
          label="Close"
          secondary={true}
          className="mr-3"
          onClick={() => this.setState({ selectPackageModalOpen: false })}
        />
      );
    } else {
      return (null);
    }
  }

  private handleSelectPackage = (attendanceMember: Member, foundPackage: MmsPackage,
    staff: Account, noShow: boolean) => {
    const { checkInProgram } = this.state;
    this.setState({
      loadingPackageSelectOrNoShow: true
    }, () => {
      this.props.checkinToday(
        attendanceMember.memberId,
        checkInProgram ? checkInProgram.id : undefined,
        staff.id,
        foundPackage ? foundPackage.id : undefined,
        noShow
      ).then(res => {
        switch (this.props.checkinState.statusCode) {
          case 200:
            this.beep();
            this.setState({
              loadingPackageSelectOrNoShow: false,
              noShowError: '',
              displayConfirmDialog: false,
              confirmationMessage: this.props.checkinState.msg
            }, this.props.getPackages);
            var today = new Date();
            this.props.getAttendance(
              new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0).getTime(),
              new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999).getTime());
            break;
          case 403:
            this.setState({
              confirmationMessage: 'Not Enough Permissions'
            });
            break;
          case 400:
            this.setState({
              loadingPackageSelectOrNoShow: false,
              noShowError: 'CheckIn with No Show did not go well'
            });
            break;
          case 406:
            this.setState(
              {
                loadingPackageSelectOrNoShow: false,
                selectPackageModalOpen: false,
                noShowError: '',
                selectedStaffs: undefined,
                confirmationMessage: this.props.checkinState.msg,
                attendanceMember: this.props.checkinState.entityMemberId ?
                  this.props.membersState.members.find((m: Member) => m.id === this.props.checkinState.entityMemberId) :
                  undefined
              }
            );
            break;
          default:
            this.setState({
              loadingPackageSelectOrNoShow: false
            });
            break;
        }
      });
    });
  }

  private handleCheckInProgramChange = (event: React.SyntheticEvent<{}>, index: number, value: Program): void =>
    this.setState({ checkInProgram: value })

  private renderManualAttendanceModeButtons = (): JSX.Element => {
    return (
      <div className="col-12 fr">
        <RaisedButton
          label="Check In"
          secondary={true}
          className="float-right mr-4"
          onClick={this.manualCheckin}
        />
        {
          this.state.loadingUnCheckin ?
            <RefreshIndicator
              size={30}
              left={10}
              top={0}
              status="loading"
              style={{
                display: 'inline-block',
                position: 'relative',
                marginLeft: '20%'
              }}
            /> :
            <RaisedButton
              label="Uncheck In"
              secondary={true}
              className="float-right mr-4"
              disabled={!this.checkIfSelectedMemberCheckedInToday()}
              onClick={this.manualUncheckin}
            />
        }
      </div>
    );
  }

  private manualUncheckin = (): void => {
    if (this.state.attendanceMode === 'MANUAL_ATTENDANCE') {
      this.unCheckinToday();
    }
  }

  private unCheckinToday = (): void => {
    const { attendanceMember } = this.state;

    this.setState({ loadingUnCheckin: true });
    this.beep();

    if (attendanceMember.memberId.length === 13) {
      const todaysAtt = this.filterTodaysCheckedinTime(this.filterAttendanceWith(attendanceMember.memberId));

      if (todaysAtt.length > 0) {
        this.props.unCheckinToday(
          attendanceMember.memberId,
          todaysAtt[todaysAtt.length - 1].time
        )
          .then(response => {
            const { checkinState } = this.props;
            switch (checkinState.statusCode) {
              case 400:
                this.setState({
                  confirmationMessage: checkinState.msg
                });
                break;
              case 403:
                this.setState({
                  confirmationMessage: 'Not Enough Permissions'
                });
                break;
              case 404:
                this.setState({
                  confirmationMessage: 'Member Not Found'
                });
                break;
              case 200:
                this.setState({
                  confirmationMessage: this.props.checkinState.entity ?
                    'Successfully Unchecked in.' :
                    'The attempted uncheck in is invalid.'
                }, this.props.getPackages);
                var today = new Date();
                this.props.getAttendance(
                  new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0).getTime(),
                  new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999).getTime());
                break;
              default:
                break;
            }

            this.setState({
              attendingMemberId: '',
              loadingUnCheckin: false
            });
            return;
          });
      }
    }
  }

  private checkIfSelectedMemberCheckedInToday = (): boolean => {
    const { attendance } = this.props.attendanceState;

    if (attendance && attendance.attendances) {
      const filtered = this.filterAttendanceWith(this.state.attendanceMember.memberId);

      return this.filterTodaysCheckedinTime(filtered) ?
        this.filterTodaysCheckedinTime(filtered).length > 0 ?
          this.filterTodaysCheckedinTime(filtered)[0].time !== DEFAULT_NOT_CHECKED_IN :
          false :
        false;
    } else {
      return false;
    }
  }

  private filterAttendanceWith = (memberId: string): Attendance => {
    const { attendances } = this.props.attendanceState.attendance;

    return attendances[attendances.findIndex((att: Attendance) => att.memberId === memberId)];
  }

  private filterTodaysCheckedinTime = (att?: Attendance): AttendanceDetail[] => {
    return att && att.attendanceDetails ?
      att.attendanceDetails[new Date().getDate()] :
      null;
  }

  private renderProgramItems = (): JSX.Element[] => {
    return (
      this.props.programsState.programs.map((p: Program, key: number) => {
        return <MenuItem key={key} value={p} primaryText={p.name} />;
      })
    );
  }

  private renderTakePicButton = (): JSX.Element => {
    if (this.state.loading) {
      return (
        <RefreshIndicator
          size={40}
          left={10}
          top={0}
          status="loading"
          style={{
            display: 'inline-block',
            position: 'relative',
            marginLeft: '50%'
          }}
        />
      );
    } else {
      return (
        <RaisedButton
          label="Face Check-in"
          primary={true}
          fullWidth={true}
          icon={<ActionCameraEnhance color={white} hoverColor={yellow500} />}
          onClick={this.faceCheckin}
        />
      );
    }
  }

  private faceCheckin = (): void => {
    this.setState(
      {
        screenshot: (this.refs.webcam as any).getScreenshot(),
        loading: !isAuthTokenExpired()
      },
      () => {
        const facePic = this.dataURLtoFile();

        if (facePic) {
          this.beep();

          this.props.faceCheckin(facePic, this.state.checkInProgram ? this.state.checkInProgram.id : undefined)
            .then(response => {
              const { checkinState } = this.props;

              switch (checkinState.statusCode) {
                case 400:
                  this.setState({
                    confirmationMessage: 'Member Not Found'
                  });
                  break;
                case 403:
                  this.setState({
                    confirmationMessage: 'Not Enough Permissions'
                  });
                  break;
                case 404:
                  this.setState({
                    confirmationMessage: 'Member Not Found'
                  });
                  break;
                case 406:
                  this.setState(
                    {
                      confirmationMessage: checkinState.msg,
                      attendanceMember: checkinState.entityMemberId ?
                        this.props.membersState.members.find((m: Member) => m.id === checkinState.entityMemberId) :
                        undefined
                    },
                  );
                  break;
                case 200:

                  if (checkinState.entity.member) {
                    if (checkinState.entity.member.memberType === PACKAGE_BASED) {
                      var data = this.setMemberPackagesForAttendedMember(checkinState.entity.member);
                      this.setState({
                        displayConfirmDialog: true,
                        selectPackageModalOpen: true,
                        memberPackages: data,
                        confirmationMessage: '',
                        foundMember: checkinState.entity.member
                      });
                    } else {
                      this.setState(
                        {
                          displayConfirmDialog: true,
                          foundMember: checkinState.entity.member
                        }
                      );
                      // setTimeout(this.clearCheckIn, 10000);
                    }
                  }
                  // var date = new Date();
                  // var from = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
                  // var to = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);
                  // this.props.getAttendance(from.getTime(), to.getTime());
                  // this.setState(
                  //   {
                  //     attendanceMode: 'MANUAL_ATTENDANCE',
                  //     confirmationMessage: checkinState.msg,
                  //     attendanceMember: checkinState.entity ? checkinState.entity.member : initialMemberDetail
                  //   }, this.checkIfPackageBasedMemberType
                  // );
                  break;
                default:
                  break;
              }

              this.setState({
                attendingMemberId: '',
                loading: false
              });
            });
        }
      }
    );
  }

  private checkIfPackageBasedMemberType = () => {
    const { attendanceMember } = this.state;

    if (attendanceMember) {
      if (attendanceMember.memberType === PACKAGE_BASED) {
        var data = this.setMemberPackagesForAttendedMember(attendanceMember);
        this.setState({ selectPackageModalOpen: true, memberPackages: data, confirmationMessage: '' });
      } else {
        setTimeout(this.clearCheckIn, 10000);
      }
    }
  }

  private dataURLtoFile = (): File | null => {
    const arr = this.state.screenshot.split(',');

    if (arr.length > 0) {
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], 'face-checkin.jpg', { type: mime });
    } else {
      return null;
    }
  }

  private manualCheckin = (): void => {
    if (this.state.attendanceMember && this.state.attendanceMember.memberType === PACKAGE_BASED) {
      this.setState({
        selectPackageModalOpen: true,
        confirmationMessage: ''
      });
    } else if (this.state.attendanceMode === 'MANUAL_ATTENDANCE') {
      this.setState(
        { attendingMemberId: this.state.attendanceMember.memberId, confirmationMessage: '' },
        this.checkinToday
      );
    }
  }

  private checkinToday() {
    const { attendingMemberId, checkInProgram } = this.state;

    this.beep();

    if (attendingMemberId.length === 13) {
      this.props.checkinToday(
        attendingMemberId,
        checkInProgram ? checkInProgram.id : undefined
      )
        .then(response => {

          const { checkinState } = this.props;

          switch (checkinState.statusCode) {
            case 400:
              this.setState({
                confirmationMessage: 'Member Not Found',
                optionsOpen: false
              });
              break;
            case 403:
              this.setState({
                confirmationMessage: 'Not Enough Permissions',
                optionsOpen: false
              });
              break;
            case 404:
              this.setState({
                confirmationMessage: 'Member Not Found',
                optionsOpen: false
              });
              break;
            case 406:
              this.setState(
                {
                  confirmationMessage: checkinState.msg,
                  optionsOpen: false,
                  attendanceMember: checkinState.entityMemberId ?
                    this.props.membersState.members.find((m: Member) => m.id === checkinState.entityMemberId) :
                    undefined
                }
              );
              break;
            case 200:
              this.setState({
                attendanceMode: 'MANUAL_ATTENDANCE',
                optionsOpen: false,
                displayConfirmDialog: checkinState.entity.member.memberType === PACKAGE_BASED ?
                  true : false,
                confirmationMessage: checkinState.msg,
                attendanceMember: checkinState.entity ? checkinState.entity.member : initialMemberDetail
              }, this.props.getPackages);
              break;
            default:
              break;
          }
          var date = new Date();
          var from = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
          var to = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);
          this.props.getAttendance(from.getTime(), to.getTime());
          if (this.state.attendanceMember.memberType !== PACKAGE_BASED) {
            setTimeout(this.clearCheckIn, 10000);
          }
        });
    }
  }

  private clearCheckIn = (): void => {
    this.setState(
      {
        attendanceMember: initialMemberDetail,
        attendingMemberId: '',
        memberSearchText: '',
        confirmationMessage: '',
        optionsOpen: false
      }
    );
  }

  private loadMembersList() {
    const { getMembers } = this.props;

    getMembers()
      .then((membersResponseData) => {
        const { membersState } = this.props;
        switch (membersState.statusCode) {
          case 404:
            return;
          case 200:
            this.setState({
              members: membersState.members.filter((m: Member) => !m.cancelled),
              memberSearchData: this.mapMemberToSearchData()
            });
            return;
          default:
            return;
        }
      });
  }

  private onAttendingMemberIdChange = (value: string): void => {
    const { attendanceMode } = this.state;
    const newMemberId = value;

    const foundMember = this.props.membersState.members.find(m => m.memberId === newMemberId);

    if (foundMember && foundMember.memberType === PACKAGE_BASED) {
      var data = this.setMemberPackagesForAttendedMember(foundMember);
      this.setState({
        attendanceMember: foundMember,
        attendanceMode: 'MANUAL_ATTENDANCE',
        memberPackages: data,
        selectPackageModalOpen: foundMember.memberType === PACKAGE_BASED
      });
    } else {
      this.setState(
        {
          attendingMemberId: newMemberId,
          memberSearchText: value,
          attendanceMode: (newMemberId.length === 13) ? 'AUTO_ATTENDANCE' : attendanceMode
        },
        () => {
          if (newMemberId.length === 13) {
            this.setState({ memberSearchText: '' });
            this.checkinToday();
          }
        });
    }
  }

  private mapMemberToSearchData = (): string[] => {
    return this.props.membersState.members.filter((m: Member) => !m.cancelled)
    .map((m: Member) => m.firstName + ' ' + m.lastName + DIVIDER + m.memberId);
  }

  private handleNewMemberSearchRequest = (chosenRequest: string, index: number): void => {
    var foundMember = this.findMemberWith(chosenRequest);
    console.log(foundMember);
    var data = {};
    if (foundMember.memberType === PACKAGE_BASED) {
      data = this.setMemberPackagesForAttendedMember(foundMember);
    }

    this.setState(
      {
        attendanceMember: foundMember,
        foundMember: foundMember,
        displayConfirmDialog: true,
        memberPackages: data,
        attendingMemberId: chosenRequest.split(DIVIDER)[3],
        attendanceMode: 'MANUAL_ATTENDANCE',
        memberSearchText: ''
      }
    );
  }

  private findMemberWith = (value: string): Member => {
    return this.props.membersState.members.find((m: Member) =>
      (m.firstName + ' ' + m.lastName) === value.split(DIVIDER)[0] &&
      m.memberId === value.split(DIVIDER)[1]
    );
  }

  private setMemberPackagesForAttendedMember = (member: Member): Object => {
    var result = this.getPackageByIdsArray(member.packageIds);
    var i;
    var data = new Object();
    for (i = 0; i < result.length; i++) {
      var obj = new Object();
      obj['id'] = result[i].id;
      data[i] = obj;
    }
    return data;
  }

  private beep = (): void => {
    var snd = new Audio(
      'data:audio/wav;base64,//' +
      'uQRAAAAWMSLwUIYAAsYkXgoQwAEaYLWfkWgAI0wWs/ItAAAGDgYtAgAyN+QWaAAihwMWm4G8QQRDiMcCBcH3Cc+CDv/' +
      '7xA4Tvh9Rz/y8QADBwMWgQAZG/ILNAARQ4GLTcDeIIIhxGOBAuD7hOfBB3/' +
      '94gcJ3w+o5/5eIAIAAAVwWgQAVQ2ORaIQwEMAJiDg95G4nQL7mQVWI6GwRcfsZAcsKkJvxgxEjzFUgfHoSQ9Qq7KNwq' +
      'HwuB13MA4a1q/DmBrHgPcmjiGoh//EwC5nGPEmS4RcfkVKOhJf+WOgoxJclFz3kgn//dBA+ya1GhurNn8zb//9NNutNu' +
      'hz31f////9vt///z+IdAEAAAK4LQIAKobHItEIYCGAExBwe8jcToF9zIKrEdDYIuP2MgOWFSE34wYiR5iqQPj0JIeoVd' +
      'lG4VD4XA67mAcNa1fhzA1jwHuTRxDUQ//iYBczjHiTJcIuPyKlHQkv/LHQUYkuSi57yQT//uggfZNajQ3Vmz+Zt//+mm' +
      '3Wm3Q576v////+32///5/EOgAAADVghQAAAAA//uQZAUAB1WI0PZugAAAAAoQwAAAEk3nRd2qAAAAACiDgAAAAAAABCq' +
      'EEQRLCgwpBGMlJkIz8jKhGvj4k6jzRnqasNKIeoh5gI7BJaC1A1AoNBjJgbyApVS4IDlZgDU5WUAxEKDNmmALHzZp0Fk' +
      'z1FMTmGFl1FMEyodIavcCAUHDWrKAIA4aa2oCgILEBupZgHvAhEBcZ6joQBxS76AgccrFlczBvKLC0QI2cBoCFvfTDAo' +
      '7eoOQInqDPBtvrDEZBNYN5xwNwxQRfw8ZQ5wQVLvO8OYU+mHvFLlDh05Mdg7BT6YrRPpCBznMB2r//xKJjyyOh+cImr2/' +
      '4doscwD6neZjuZR4AgAABYAAAABy1xcdQtxYBYYZdifkUDgzzXaXn98Z0oi9ILU5mBjFANmRwlVJ3/6jYDAmxaiDG3/6x' +
      'jQQCCKkRb/6kg/wW+kSJ5//rLobkLSiKmqP/0ikJuDaSaSf/6JiLYLEYnW/+kXg1WRVJL/9EmQ1YZIsv/6Qzwy5qk7/+tE' +
      'U0nkls3/zIUMPKNX/6yZLf+kFgAfgGyLFAUwY//uQZAUABcd5UiNPVXAAAApAAAAAE0VZQKw9ISAAACgAAAAAVQIygIElVr' +
      'FkBS+Jhi+EAuu+lKAkYUEIsmEAEoMeDmCETMvfSHTGkF5RWH7kz/ESHWPAq/kcCRhqBtMdokPdM7vil7RG98A2sc7zO6ZvT' +
      'dM7pmOUAZTnJW+NXxqmd41dqJ6mLTXxrPpnV8avaIf5SvL7pndPvPpndJR9Kuu8fePvuiuhorgWjp7Mf/PRjxcFCPDkW31s' +
      'rioCExivv9lcwKEaHsf/7ow2Fl1T/9RkXgEhYElAoCLFtMArxwivDJJ+bR1HTKJdlEoTELCIqgEwVGSQ+hIm0NbK8WXcTEI' +
      '0UPoa2NbG4y2K00JEWbZavJXkYaqo9CRHS55FcZTjKEk3NKoCYUnSQ0rWxrZbFKbKIhOKPZe1cJKzZSaQrIyULHDZmV5K4x' +
      'ySsDRKWOruanGtjLJXFEmwaIbDLX0hIPBUQPVFVkQkDoUNfSoDgQGKPekoxeGzA4DUvnn4bxzcZrtJyipKfPNy5w+9lnXwgq' +
      'siyHNeSVpemw4bWb9psYeq//uQZBoABQt4yMVxYAIAAAkQoAAAHvYpL5m6AAgAACXDAAAAD59jblTirQe9upFsmZbpMudy7L' +
      'z1X1DYsxOOSWpfPqNX2WqktK0DMvuGwlbNj44TleLPQ+Gsfb+GOWOKJoIrWb3cIMeeON6lz2umTqMXV8Mj30yWPpjoSa9ujK8' +
      'SyeJP5y5mOW1D6hvLepeveEAEDo0mgCRClOEgANv3B9a6fikgUSu/DmAMATrGx7nng5p5iimPNZsfQLYB2sDLIkzRKZOHGAaUy' +
      'DcpFBSLG9MCQALgAIgQs2YunOszLSAyQYPVC2YdGGeHD2dTdJk1pAHGAWDjnkcLKFymS3RQZTInzySoBwMG0QueC3gMsCEYxUql' +
      'rcxK6k1LQQcsmyYeQPdC2YfuGPASCBkcVMQQqpVJshui1tkXQJQV0OXGAZMXSOEEBRirXbVRQW7ugq7IM7rPWSZyDlM3IuNEkxzC' +
      'OJ0ny2ThNkyRai1b6ev//3dzNGzNb//4uAvHT5sURcZCFcuKLhOFs8mLAAEAt4UWAAIABAAAAAB4qbHo0tIjVkUU//uQZAwABfSF' +
      'z3ZqQAAAAAngwAAAE1HjMp2qAAAAACZDgAAAD5UkTE1UgZEUExqYynN1qZvqIOREEFmBcJQkwdxiFtw0qEOkGYfRDifBui9MQg4Q' +
      'AHAqWtAWHoCxu1Yf4VfWLPIM2mHDFsbQEVGwyqQoQcwnfHeIkNt9YnkiaS1oizycqJrx4KOQjahZxWbcZgztj2c49nKmkId44S71' +
      'j0c8eV9yDK6uPRzx5X18eDvjvQ6yKo9ZSS6l//8elePK/Lf//IInrOF/FvDoADYAGBMGb7FtErm5MXMlmPAJQVgWta7Zx2go+8xJ' +
      '0UiCb8LHHdftWyLJE0QIAIsI+UbXu67dZMjmgDGCGl1H+vpF4NSDckSIkk7Vd+sxEhBQMRU8j/12UIRhzSaUdQ+rQU5kGeFxm+hb' +
      '1oh6pWWmv3uvmReDl0UnvtapVaIzo1jZbf/pD6ElLqSX+rUmOQNpJFa/r+sa4e/pBlAABoAAAAA3CUgShLdGIxsY7AUABPRrgCABd' +
      'DuQ5GC7DqPQCgbbJUAoRSUj+NIEig0YfyWUho1VBBBA//uQZB4ABZx5zfMakeAAAAmwAAAAF5F3P0w9GtAAACfAAAAAwLhMDmAYWM' +
      'gVEG1U0FIGCBgXBXAtfMH10000EEEEEECUBYln03TTTdNBDZopopYvrTTdNa325mImNg3TTPV9q3pmY0xoO6bv3r00y+IDGid/9aa' +
      'aZTGMuj9mpu9Mpio1dXrr5HERTZSmqU36A3CumzN/9Robv/Xx4v9ijkSRSNLQhAWumap82WRSBUqXStV/YcS+XVLnSS+WLDroqArF' +
      'kMEsAS+eWmrUzrO0oEmE40RlMZ5+ODIkAyKAGUwZ3mVKmcamcJnMW26MRPgUw6j+LkhyHGVGYjSUUKNpuJUQoOIAyDvEyG8S5yfK6' +
      'dhZc0Tx1KI/gviKL6qvvFs1+bWtaz58uUNnryq6kt5RzOCkPWlVqVX2a/EEBUdU1KrXLf40GoiiFXK///qpoiDXrOgqDR38JB0bw7S' +
      'oL+ZB9o1RCkQjQ2CBYZKd/+VJxZRRZlqSkKiws0WFxUyCwsKiMy7hUVFhIaCrNQsKkTIsLivwKKigsj8XYlwt/WKi2N4d//uQRCSAA' +
      'jURNIHpMZBGYiaQPSYyAAABLAAAAAAAACWAAAAApUF/Mg+0aohSIRobBAsMlO//Kk4soosy1JSFRYWaLC4qZBYWFRGZdwqKiwkNBVmo' +
      'WFSJkWFxX4FFRQWR+LsS4W/rFRb/////////////////////////////////////////////////////////////////////////////' +
      '////////////////////////////////////////////////////////////////////////////////////////////////////////' +
      '////////////////////////////////////////////////////////////////////////////////////////////////////////' +
      '////////////////////////////////////////////////////////////////////////////////////////////////////////' +
      '////////////////////////////VEFHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAU291bmRib3kuZGUAAAAAAAAAAAAAAAAA' +
      'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMjAwNGh0dHA6Ly93d3cuc291bmRib3kuZGUAAAAAAAAAACU='
    );
    snd.play();
  }
}

export default AttendanceCheckInComponent;



// WEBPACK FOOTER //
// ./src/attendance/AttendanceCheckInComponent.tsx